// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__ze2cl","overlayShow":"Dialog_overlayShow__1xpHe"};